import React from 'react';
import SIcon from './SIcon';
import { faPlayCircle } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faPlayCircle} fa />;

export default Icon;
